import { Button, Checkbox, Grid, IconButton, InputBase, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { CheckBox, Close } from '@material-ui/icons';
import { Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { CloseIcon, CloseIconColor, DownArrow, UpArrow } from 'src/components/Icons';
import { SearchBar } from 'src/components/sub-components/SearchBar';
import useStyles from '../../assets/styles';
import { FilterBatchNumber } from './FilterBatchNumber';
import { DropDown } from 'src/app/setup-senzmatica/step-3/components/DropDown';
import { BatchFilter } from 'src/app/alert-setting/components/BatchFilter';

export const MultiSelectDropDown = (props) => {
    const classes = useStyles()
    const [filterDevices, setFilterDevices] = useState(props.options)
    const [searchTerm, setSearchTerm] = useState('')
    const dropdownRef = useRef(null);
    const [filterVisible, setFilterVisible] = useState(false);
    const [selectedBatch, setSelectedBatch] = useState('');

    const handleBatchSelect = (batch) => {
        setSelectedBatch(batch);
    };

    const toggleFilter = () => {
        setFilterVisible(!filterVisible);
    };

    const resetFilteredDevices = () => {
        setFilterDevices(props.options);
        setSelectedBatch('');
    };

    const filterBatch = () =>{  
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        const filtered = filterDevices.filter(device => {
            if(device.batchNumber){
                const matchesBatch = device.batchNumber.includes(selectedBatch);
                const matchesSearch = device.batchNumber.toLowerCase().includes(lowerCaseSearchTerm)
                return matchesBatch && matchesSearch;
            }
        })
        setFilterDevices(filtered);
        setFilterVisible(false)
    }

    useEffect(() => {
        setFilterDevices(props.options);
    }, [props.options]);

    const handleSelectDevice = (device) => {
        props.setSelectedDevices(prevDevices => {
            const currentIds = prevDevices.map(d => typeof d === 'string' ? d : d.id);
            const deviceId = device.id || device;
            
            if (currentIds.includes(deviceId)) {
                return currentIds.filter(id => id !== deviceId);
            } else {
                return [...currentIds, deviceId];
            }
        });

        if (props.setErrors && props.errors.deviceError) {
            props.setErrors(prev => ({...prev, deviceError: null}));
        }
    };

    const handleSearch = (event) => {
        const { value } = event.target;
        setSearchTerm(value.toLowerCase());
    
        if (value) {
            if (props.type === 'devices') {
                const filteredData = props.options.filter(device =>
                    device.id.toLowerCase().includes(value)
                );
                setFilterDevices(filteredData);
            } else {
                const filteredData = props.options.filter(device =>
                    device.id.toString().toLowerCase().includes(value)
                );
                setFilterDevices(filteredData);
            }
        } else {
            setFilterDevices(props.options);
        }
    };

    const shouldShowSearchBar = (): boolean => {
        if (!props.isBatch) return true;
        
        return (props.options && props.options.length > 0);
    };

    const shouldShowFilter = (): boolean => {
        return props.isBatch &&
            props.options && 
            props.options.length > 0;
    };

    console.log(props.isBatch, props.options)

    const shouldShowTable = props.isBatch ? 
        (props.options && props.options.length > 0) : 
        true;

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            props.setIsDropdownVisible(false)
        }
    }

    return (
        <Grid container ref={dropdownRef}>
            <Grid item xs={12} md={12} style={{ display: 'flex', flexDirection:'row', alignItems: 'center', justifyContent: 'space-between' }}>
                {shouldShowSearchBar() && (
                    <Grid 
                        item 
                        xs={shouldShowFilter() ? 6 : 12} 
                        md={shouldShowFilter() ? 4 : 12} 
                        style={{ marginRight: shouldShowFilter() ? '10px' : '0' }}
                    >
                        <SearchBar onChange={handleSearch}/>
                    </Grid>
                )}

                {shouldShowFilter() && (
                    <Grid item xs={6} md={2}>
                        <BatchFilter 
                            toggleFilter={toggleFilter}
                            handleBatchSelect={handleBatchSelect}
                            filterVisible={filterVisible}
                            setFilterVisible={setFilterVisible}
                            batches={props.selectedBatches}
                            selectedBatch={selectedBatch}
                            filterBatch={filterBatch}
                            setSelectedBatch={setSelectedBatch}
                            filterType="batchNumber"
                            onCancel={resetFilteredDevices}
                        />
                    </Grid>
                )}
            </Grid>
            
            {props.type == 'productType' && (
                <Grid container style={{ marginTop: '10px', fontFamily: "Poppins", fontWeight: 400, fontSize: "14px" }}>
                    <Grid item xs={6} md={6}>
                        <Typography>Product Type Version</Typography>
                    </Grid>
                    <Grid item xs={12} md={12} style={{ marginTop: '10px' }}>
                        <DropDown
                            options={props.productTypeVersions}
                            type='option'
                            placeholder='Select Product Type Version'
                            setSelectKitModel={props.setSelectedProductTypeVersion}
                            isAddRequired={false}
                            isSingle={true}
                            value={props.selectedProductTypeVersion}
                            onClick={(event) => props.handleSelectProductTypeVersion(event)}
                        />
                    </Grid>
                </Grid>
            )}

            {shouldShowTable && (
                <Grid container 
                    className={classes.multiSelectDropDownTable} 
                    style={props.type === 'devices' ? { marginBottom: '10px' } : { marginBottom: '30px' }}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableCell} align="left"></TableCell>
                                <TableCell className={classes.tableCell} align="left">Device ID</TableCell>
                                <TableCell className={classes.tableCell} align="left">Last Seen</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filterDevices.map((device, index) => (
                                <TableRow style={{ backgroundColor: index % 2 == 1 ? '#FFFFFF' : '#F5F5F5' }} key={index}>
                                    <TableCell align="left">
                                        <Checkbox
                                            classes={{ checked: classes.checked }}
                                            checked={props.selectedDevices.some(selected => 
                                                (typeof selected === 'string' ? selected : selected.id) === device.id
                                            )}
                                            onClick={() => handleSelectDevice(device)}
                                            className="check-box"
                                        />
                                    </TableCell>
                                    <TableCell align="left">
                                        {device.id}
                                        {props.isBatch ? ` (${device.batchNumber})` : ''}
                                    </TableCell>
                                    <TableCell align="left">
                                        {device.lastSeen && device.lastSeen != '' ? device.lastSeen : 'N/A'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
            )}

            {props.errors && props.errors.deviceError && (
                <Grid container style={{ marginTop: '10px' }}>
                    <Grid item xs={12}>
                        <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                            {props.errors.deviceError}
                        </Typography>
                    </Grid>
                </Grid>
            )}

            <Grid container justifyContent='flex-end' style={!shouldShowTable ? { marginTop: '10px' } : { marginTop: '0px' }}>
                <Button variant='outlined' style={{ width: '100px' }} onClick={props.handleCancel}>
                    {props.type === 'devices' ? 'Back' : 'Cancel'}
                </Button>
                <Button variant='outlined' className={classes.deviceAddButton} onClick={props.handleSave}>
                    {props.formType === 'edit' ? 'Update' : 'Add'} 
                </Button>
            </Grid>
        </Grid>
    );
}

export const DeviceCard = ({ device, onClose }) => {
    const classes = useStyles()
    return (
        <Grid container className={classes.deviceCard}>
            <label style={{ marginRight: '10px' }}>{device}</label>
            <IconButton onClick={() => onClose(device)}>
                <CloseIcon color='#2A7BEC' />
            </IconButton>

        </Grid>
    )
}
